import { SendMessageDilogComponent } from './sendmessage/sendmessage.component';
import { DialogModule, MultiSelectModule } from 'primeng/primeng';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from "ng-zorro-antd";
import { CopyDirective } from "./copy/copy.directive";
import { RevocationDirective } from "./revocation/revocation.directive";
import { OrderDetailComponent } from "./orderdetail/orderdetail.directive";
import { SubDigetPipe } from './../../pipes/subDiget.pipe';
import { DragDirective } from "./drag/drag.directive";
import { TimeinfoPipe } from '../../pipes/timeinfo.pipe';
import { TopupdetailComponent } from './topupdetail/topupdetail.component';
import { TopdetailComponent } from './topdetail/topdetail.component';
import { SlideBannerComponent } from './topdetail/slide.component';
import { SliderVerificationComponent } from '../login/slider-verification/slider-verification.component';
import { SliderCaptchaComponent } from '../login/slider-captcha/slider-captcha.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    DialogModule,
    MultiSelectModule
  ],
  declarations: [
    SendMessageDilogComponent,
    OrderDetailComponent,
    RevocationDirective,
    CopyDirective,
    SubDigetPipe,
    DragDirective,
    TimeinfoPipe,
    TopupdetailComponent,
    TopdetailComponent,
    SlideBannerComponent,
    SliderVerificationComponent,
    SliderCaptchaComponent
  ],
  exports: [
    SendMessageDilogComponent,
    OrderDetailComponent,
    RevocationDirective,
    CopyDirective,
    CommonModule,
    FormsModule,
    SubDigetPipe,
    DragDirective,
    TopupdetailComponent,
    TopdetailComponent,
    SlideBannerComponent,
    TimeinfoPipe,
    SliderVerificationComponent,
    SliderCaptchaComponent

  ]
})
export class SharedModule { }


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/shared.module.ts